interface ProgressBarProps {
 steps: string[];
 currentStep: number;
 onStepClick: (index: number) => void;
}

export function ProgressBar({ steps, currentStep, onStepClick }: ProgressBarProps) {
 return (
 <div className="border-b border-slate-700 px-2 sm:px-4 lg:px-6 py-2 flex items-center gap-0.5 sm:gap-1 overflow-x-auto">
 <span className="text-[10px] font-semibold uppercase tracking-wide text-accent-orange whitespace-nowrap hidden sm:inline mr-1">Journey</span>
 {steps.map((title, i) => (
 <button
 key={i}
 onClick={() => onStepClick(i)}
 className={`flex items-center gap-1 sm:gap-1.5 px-1.5 sm:px-2 py-1 rounded text-xs whitespace-nowrap transition-all flex-shrink-0 ${
 i === currentStep
 ?'bg-accent-orange text-slate-50 font-semibold'
 : i < currentStep
 ?'bg-slate-700/70 text-slate-300'
 :'text-slate-500 hover:text-slate-300'
 }`}
 >
 <span
 className={`w-5 h-5 rounded-full flex items-center justify-center text-[10px] font-bold flex-shrink-0 ${
 i === currentStep
 ?'bg-white text-accent-orange'
 : i < currentStep
 ?'bg-accent-green text-white'
 :'bg-slate-600 text-slate-400'
 }`}
 >
 {i < currentStep ?'✓' : i + 1}
 </span>
 <span className="hidden sm:inline">{title}</span>
 </button>
 ))}
 {/* Progress percentage for small mobile */}
 <div className="ml-auto pl-2 text-[10px] text-slate-500 font-mono flex-shrink-0 sm:hidden">
 {Math.round(((currentStep + 1) / steps.length) * 100)}%
 </div>
 </div>
 );
}
